import { createContext } from "react";

import { ToastProps } from "./Toast";

export const ToastContext = createContext<{
  toast: (options: Omit<ToastProps, "toastId">) => void;
}>(null as any);
